var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Esta seguro que desea eliminar el registro # "+_vm._s(_vm.rc.id)+" de "+_vm._s(_vm.rc.p_nombre)+" "+_vm._s(_vm.rc.p_apellido)+"? ")])
}
var staticRenderFns = []

export { render, staticRenderFns }